<template>
  <ca-rollover
    ref="rollover"
    :title="title">
    <ca-async-content-wrapper
      :on-fetch="onFetchSelfEmployedPayment"
      :on-fetch-success="onFetchSuccess">
      <ca-row vertical-offset="2">
        <ca-col>
          <ca-table>
            <ca-tr slot="header">
              <ca-th>Descrição</ca-th>
              <ca-th>Pagamento</ca-th>
              <ca-th align="right">Proventos</ca-th>
              <ca-th align="right">Descontos</ca-th>
              <ca-th></ca-th>
            </ca-tr>

            <ca-tr v-for="(movement, index) in selfEmployedPayment.movements" :key="index">
              <ca-td>{{ movement.description }}</ca-td>
              <ca-td>{{ movement.paymentDate | caDate }}</ca-td>
              <ca-td v-if="isEarning(movement)" align="right">
                {{ movement.amount | brazilianCurrency }}
              </ca-td>
              <ca-td v-else align="right">
              </ca-td>
              <ca-td v-if="isDiscount(movement)" align="right">
                {{ movement.amount | brazilianCurrency }}
              </ca-td>
              <ca-td v-else align="right">
              </ca-td>
              <ca-td></ca-td>
            </ca-tr>
            <ca-tr slot="footer">
              <ca-td>
              </ca-td>
              <ca-td>
              </ca-td>
              <ca-td align="right">
                {{ selfEmployedPayment.grossTotal | brazilianCurrency }}
              </ca-td>
              <ca-td align="right">
                {{ selfEmployedPayment.discountTotal | brazilianCurrency }}
              </ca-td>
              <ca-td>
              </ca-td>
            </ca-tr>

            <ca-tr slot="footer">
              <ca-td align="right">
                INSS % {{ selfEmployedPayment.inssPercent }}
              </ca-td>
              <ca-td align="right">
                INSS {{ selfEmployedPayment.inssValue | brazilianCurrency }}
              </ca-td>
              <ca-td align="right">
                ISS % {{ selfEmployedPayment.issPercent }}
              </ca-td>
              <ca-td align="right">
                ISS {{ selfEmployedPayment.issValue | brazilianCurrency }}
              </ca-td>
              <ca-td>
              </ca-td>
            </ca-tr>
            <ca-tr slot="footer">
              <ca-td align="right">
                Base IRPF {{ selfEmployedPayment.irrfBasis | brazilianCurrency }}
              </ca-td>
              <ca-td align="right">
                IRPF % {{ selfEmployedPayment.irrfPercent }}
              </ca-td>
              <ca-td align="right">
                Dedução IRPF {{ selfEmployedPayment.irrfDeduction | brazilianCurrency }}
              </ca-td>
              <ca-td align="right">
                IRPF {{ selfEmployedPayment.irrfValue | brazilianCurrency }}
              </ca-td>
              <ca-td>
              </ca-td>
            </ca-tr>

            <ca-tr slot="footer">
              <ca-td align="right" colspan="5">
                {{ 'Líquido a receber: ' }}{{ selfEmployedPayment.netTotal | brazilianCurrency }}
              </ca-td>
            </ca-tr>
          </ca-table>
        </ca-col>
      </ca-row>
    </ca-async-content-wrapper>

    <ca-row slot="footer">
      <ca-col size="2">
        <ca-button full-width @click="$refs.rollover.close()">
          Fechar
        </ca-button>
      </ca-col>
      <ca-col offset="6" size="4">
        <ca-request-button
          :on-request="onDownload"
          :on-request-success="onDownloadSuccess"
          :on-request-error="onDownloadError"
          theme="primary">
          Fazer download do RPA
        </ca-request-button>
      </ca-col>
    </ca-row>
  </ca-rollover>
</template>

<script>
import { downloadFile } from 'packages/common/utils/file';
import { getRpa, getPaymentById } from '../paymentService';

export default {
  name: 'DetailsRollover',
  props: {
    id: String,
    period: String,
  },
  data() {
    return {
      selfEmployedPayment: {
        movements: [],
        selfEmployed: {},
      },
    };
  },
  computed: {
    title() {
      return this.selfEmployedPayment.selfEmployed?.name || '';
    },
  },
  methods: {
    onFetchSelfEmployedPayment() {
      return getPaymentById(this.id);
    },
    onFetchSuccess(data) {
      this.selfEmployedPayment = data;
    },
    isEarning(movement) {
      return movement.eventNature.name === 'EARNING';
    },
    isDiscount(movement) {
      return movement.eventNature.name === 'DISCOUNT';
    },
    onDownload() {
      const params = {
        type: 'SELF_EMPLOYED_PAYMENT_RECEIPT',
        format: 'PDF',
        competence: this.period,
        id: this.selfEmployedPayment.id,
      };
      return getRpa(params);
    },
    onDownloadSuccess(response) {
      downloadFile(response, 'rpa');
    },
    onDownloadError() {
      this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
    },
  },
};
</script>
